module.exports = __webpack_public_path__ + "static/hero-background-4e6682c04edc91d90cf8b3d985144182.svg";